// extracted by mini-css-extract-plugin
export default {"auth__wrapper":"styles_auth__wrapper__mWTlo","auth__error":"styles_auth__error__Y7XCn"};